import React, { FC, ReactNode } from 'react';
import { createActorContext } from '@xstate/react';

import { productPurchaseMachine } from '../../../../state-machines/purchase/product-purchase-machine';

export const ProductPurchaseServiceContext = createActorContext(
  productPurchaseMachine,
);

export const ProductPurchaseServiceContextProvider: FC<{
  children: ReactNode;
}> = ({ children }) => {
  return (
    <ProductPurchaseServiceContext.Provider>
      {children}
    </ProductPurchaseServiceContext.Provider>
  );
};
